import { flatMap } from "lodash-es";
import React, { FC, useMemo } from "react";
import { useRouter } from "router";

import { Select } from "@/components/Select";
import { router } from "@/views/router";

import { ITabOption, TTabOption } from "./types";

interface ITabSelectProps {
  pathName: string;
  routeParam: string;
  options: TTabOption[];
  onChange?: (value: string) => void;
}

export const TabSelect: FC<ITabSelectProps> = ({ pathName, routeParam, options, onChange }) => {
  const reactRouter = useRouter<{}, Record<string, string>>();

  const flatOptions = flatMap(options, o => (o.type === "group" ? o.options : o));

  const paramValue = reactRouter.searchParams[routeParam];
  const foundOptionIndex = flatOptions.findIndex(o => o.value === paramValue);
  const activeOptionIndex = foundOptionIndex === -1 ? 0 : foundOptionIndex;
  const activeOption = flatOptions[activeOptionIndex];

  const selectOptions = useMemo(() => options.filter(o => o.type === "option" || !o.hide), [options]);

  const handleValueChange = (value: ITabOption) => {
    const routerPath = router.get(pathName, value.params ?? {}, {
      ...reactRouter.searchParams,
      [routeParam]: value.value.trim(),
    });
    reactRouter.push(routerPath.path);
    if (onChange) {
      onChange(value.value);
    }
  };

  return (
    <Select
      size="lg"
      isClearable={false}
      isSearchable={false}
      options={selectOptions}
      valueKey="value"
      labelKey="label"
      value={activeOption}
      onChange={handleValueChange}
      hideSelectedOptions={false}
    />
  );
};
